<template>
    <div>
      <div class="page-wrapper">
          <header class="header">
          <!-- End .header-top -->
              <div class="header-middle sticky-header clear-menu-header">
                  <div class="container">
                      <div class="header-left">
                          <button class="mobile-menu-toggler" type="button">
                              <i class="icon-menu"></i>
                          </button>
                          <a href="index.html" class="logo">
                              <img src="/assets/images/logo.png" alt="Eurosan Logo">
                          </a>
                      </div><!-- End .header-left -->
                  </div><!-- End .container -->
              </div><!-- End .header-middle -->
          </header><!-- End .header -->
          <main class="main home success-page">
              <div class="container">
                  <div class="success-text-wrapper">
                      <div class="icon-wrapper">
                          <i class="sicon-check success-check"></i>
                      </div>
                      <h1 class="account-sub-title d-md-block">
                        {{ translations.newsletterConfirm.great }}
                      </h1>
                      <p>{{ translations.passwordResetSuccess }}</p>
                      <!--<p>Transakcije je uspješno obavljena</p>-->
                      <div class="success-btn-back">
                          <router-link
                            class="btn btn-primary active"
                            :to="{ name: route }"
                          >
                            {{ translations.backToLogin }} ({{ time }})
                          </router-link>
                      </div>
                  </div>
              </div><!-- End .container -->
          </main><!-- End .main -->
      </div><!-- End .page-wrapper -->
      <div class="mobile-menu-overlay"></div><!-- End .mobil-menu-overlay -->
    </div>
  </template>
<script>
import { translations } from '@/mixins';

export default {
  name: 'PasswordResetSuccess',
  mixins: [translations],
  data() {
    return {
      time: 5,
    };
  },
  props: {
    query: Object,
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const timerId = setTimeout(() => {
      this.$router.push({ name: 'Login' });

      clearTimeout(timerId);
    }, 5000);

    const intervalId = setInterval(() => {
      if (this.time <= 1) {
        clearInterval(intervalId);
      }
      this.time -= 1;
    }, 1000);
  },
  computed: {
    route() {
      return 'Login';
    },
  },
};
</script>
<style lang="scss" scoped>
.newsletter-wrapper {
  height: 100vh;
}

/*Success Page*/

.success-page {
    height: calc(100vh - 73px);
}

.success-text-wrapper {
    width: 600px;
    height: 365px;
    background: white;
    box-shadow: 0 12px 20px 0 rgb(0 0 0 / 8%);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.icon-wrapper {
    text-align: center;
    padding-top: 45px;
    padding-bottom: 45px;
    background: #1e84bc;
    color: #ffffff;
    margin-bottom: 30px;
}

.success-check {
    font-size: 64px;
}

.success-text-wrapper h1, .success-text-wrapper p {
    text-align: center;
    font-weight: 400;
}

.success-btn-back {
    text-align: center;
    margin-top: 42px;
}

@media (max-width: 768px) {
    .success-text-wrapper {
        width: 350px;
    }
}
</style>
